(function(){'use strict';
var CFG=null,head=null,items=[],captured=false,mq=null;
var RSEL='.wt-product__info .wt-rating, .vc-mobile-head .wt-rating';

function cfg(){
  var e=document.getElementById('vc-pdp-tweaks');
  if(!e)return null;
  var d=e.dataset;
  return{
    enabled:d.enabled!=='false',
    moveTitle:d.moveTitle!=='false',
    moveRating:d.moveRating!=='false',
    movePrice:d.movePrice!=='false',
    bp:parseInt(d.breakpoint||'899',10),
    sel:d.reviewsSelector||'',
    clickable:d.clickable!=='false',
    offset:parseInt(d.offset||'20',10)
  };
}

function gallery(){return document.querySelector('gallery-section.wt-product__gallery');}
function anyMove(){return !!(CFG&&(CFG.moveTitle||CFG.moveRating||CFG.movePrice));}

/* Remember each element's original slot with a comment node, so it can go back on desktop. */
function grab(el){
  if(!el||!el.parentNode)return;
  for(var i=0;i<items.length;i++){if(items[i].el===el)return;}
  var ph=document.createComment('vc-home');
  el.parentNode.insertBefore(ph,el);
  items.push({el:el,ph:ph});
}

function capture(){
  if(captured)return;
  if(CFG.moveTitle){
    var h=document.querySelector('.wt-product__info h1.wt-product__name');
    grab(h?(h.closest('[data-block-id]')||h.parentElement):null);
  }
  if(CFG.moveRating)grab(document.querySelector('.wt-product__info .wt-rating'));
  if(CFG.movePrice)grab(document.querySelector('.wt-product__info .wt-product__price'));
  captured=items.length>0;
}

/* Only add wrapping behaviour when the gallery's parent really is a row flexbox.
   Never apply layout properties to that container blindly. */
function flagParent(p){
  if(!p||!p.classList)return;
  var cs=null;try{cs=window.getComputedStyle(p);}catch(e){return;}
  var d=cs.display||'';
  if(d==='flex'||d==='inline-flex'){
    p.classList.add('vc-flexparent');
    if((cs.flexDirection||'row').indexOf('row')===0)p.classList.add('vc-flexrow');
    else p.classList.remove('vc-flexrow');
  }else{
    p.classList.remove('vc-flexparent');
    p.classList.remove('vc-flexrow');
  }
}
function unflagParent(p){
  if(!p||!p.classList)return;
  p.classList.remove('vc-flexparent');
  p.classList.remove('vc-flexrow');
}

function toMobile(){
  var g=gallery();
  if(!g||!g.parentNode)return;
  if(!head){head=document.createElement('div');head.className='vc-mobile-head';}
  flagParent(g.parentNode);
  if(head.parentNode!==g.parentNode||head.nextElementSibling!==g)g.parentNode.insertBefore(head,g);
  var ok=true,i;
  for(i=0;i<items.length;i++){if(head.children[i]!==items[i].el){ok=false;break;}}
  if(!ok){for(i=0;i<items.length;i++)head.appendChild(items[i].el);}
}

function toDesktop(){
  var g=gallery();
  if(g)unflagParent(g.parentNode);
  for(var i=0;i<items.length;i++){
    var it=items[i];
    if(it.ph&&it.ph.parentNode&&head&&it.el.parentNode===head)it.ph.parentNode.insertBefore(it.el,it.ph);
  }
  if(head&&head.parentNode)head.parentNode.removeChild(head);
}

function sync(){
  if(!CFG||!CFG.enabled)return;
  if(!anyMove()){toDesktop();return;}
  capture();
  if(!items.length)return;
  if(window.matchMedia('(max-width:'+CFG.bp+'px)').matches)toMobile();else toDesktop();
}

function reviewsTarget(){
  var parts=(CFG.sel||'').split(',');
  for(var i=0;i<parts.length;i++){
    var s=parts[i].trim();
    if(!s)continue;
    var el=null;
    try{el=document.querySelector(s);}catch(e){el=null;}
    if(el)return el;
  }
  return null;
}

function markClickable(){
  if(!CFG||!CFG.clickable)return;
  var list=document.querySelectorAll(RSEL);
  for(var i=0;i<list.length;i++){
    var r=list[i];
    if(r.dataset.vcLink)continue;
    r.dataset.vcLink='1';
    r.classList.add('vc-rating-link');
    r.setAttribute('role','button');
    r.setAttribute('tabindex','0');
    r.setAttribute('title','Read customer reviews');
  }
}

function jump(){
  var t=reviewsTarget();
  if(!t)return;
  var y=t.getBoundingClientRect().top+window.pageYOffset-(CFG.offset||0);
  try{window.scrollTo({top:y,behavior:'smooth'});}catch(e){window.scrollTo(0,y);}
}

function hit(t){
  var r=t&&t.closest?t.closest('.wt-rating'):null;
  return (r&&r.dataset.vcLink)?r:null;
}

function bind(){
  document.addEventListener('click',function(e){
    if(!CFG||!CFG.clickable)return;
    if(!hit(e.target))return;
    e.preventDefault();
    jump();
  },false);
  document.addEventListener('keydown',function(e){
    if(!CFG||!CFG.clickable)return;
    if(e.key!=='Enter'&&e.key!==' ')return;
    if(!hit(e.target))return;
    e.preventDefault();
    jump();
  },false);
}

function init(){
  CFG=cfg();
  if(!CFG||!CFG.enabled)return;
  sync();
  markClickable();
  if(!window.__vcTweaksBound){
    window.__vcTweaksBound=1;
    bind();
    mq=window.matchMedia('(max-width:'+CFG.bp+'px)');
    if(mq.addEventListener)mq.addEventListener('change',sync);
    else if(mq.addListener)mq.addListener(sync);
    window.addEventListener('resize',function(){clearTimeout(window.__vcTweaksT);window.__vcTweaksT=setTimeout(sync,150);},{passive:true});
    setInterval(function(){sync();markClickable();},1200);
  }
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',function(){captured=false;items=[];head=null;setTimeout(init,300);});
})();
